import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {CHANGE_TX_RISK_LEVELS, DEFAULTS, izBlank, izEmpty, izNotEmpty, LOG_OUT} from "../constants";
import {UserAction} from "../actions/UserAction";
import {message, Table, Tooltip} from "antd";
import TransactionService from "../services/transaction.service";
import CustomerService from "../services/customer.service";
import i18n from "i18next";
import AuthService from "../services/auth.service";
import CommonService from "../services/common.service";
import {CommonAction} from "../actions/CommonAction";
import SearchCardModal from "./SearchCardModal";
import TransactionActionSelect from "./TransactionActionSelect";

class TransactionTable extends Component {

    constructor(props) {
        super(props)

        const txRiskLevels = this.props.common.txRiskLevels
        const customerRiskLevels = this.props.common.customerRiskLevels

        this.state = {
            txRiskLevels: txRiskLevels,
            txLevelColors: DEFAULTS.txLevelColors,
            customerRiskLevels: customerRiskLevels,
            columns: [
                {
                    title: i18n.t('txId'),
                    dataIndex: 'txId',
                    key: 'txId',
                    fixed: 'left',
                    render: (itemId, record) => this.txId(record)
                },
                {
                    title: i18n.t('customerNo'),
                    dataIndex: 'customer.customerNo',
                    key: 'customer.customerNo',
                    fixed: 'left',
                    hideOnCustomerProfile: true,
                    render: customerNo => this.customerNo(customerNo)
                },
                {
                    title: i18n.t('customerFullName'),
                    dataIndex: 'customer.fullName',
                    key: 'customer.fullName',
                    hideOnCustomerProfile: true,
                    render: fullName => {
                        return fullName.length < 30
                            ? fullName
                            : <Tooltip placement="topLeft" title={fullName}>
                                {fullName.substring(0, 30)}...
                            </Tooltip>
                    }
                },
                {
                    title: i18n.t('tckn_vkn'),
                    dataIndex: 'customer.tckn',
                    key: 'customer.tckn',
                    hideOnCustomerProfile: true,
                    render: (itemId, record) => this.tcknVkn(record)
                },
                {
                    title: i18n.t('policyContractNo'),
                    dataIndex: 'policyContractNo',
                    key: 'policyContractNo',
                    render: (itemId, record) => this.extractFromTxData(record, 'policyContractNo')
                },
                {
                    title: i18n.t('txType'),
                    dataIndex: 'txType',
                    key: 'txType',
                    render: (itemId, record) => this.txType(record)
                },
                {
                    title: i18n.t('txPrice'),
                    dataIndex: 'txPrice',
                    key: 'txPrice',
                    render: txPrice => txPrice
                },
                {
                    title: i18n.t('txDate'),
                    dataIndex: 'txDate',
                    key: 'txDate',
                    render: txDate => txDate
                },
                {
                    title: i18n.t('agentCode'),
                    dataIndex: 'agentCode',
                    key: 'agentCode',
                    render: agentCode => agentCode
                },
                {
                    title: i18n.t('sanctionPePCheck'),
                    dataIndex: 'sanctionFound',
                    key: 'sanctionFound',
                    render: (itemId, record) => this.sanctionFound(record)
                },
                {
                    title: i18n.t('customerRiskScore'),
                    dataIndex: 'calculatedCustomerScoreOnThis',
                    key: 'calculatedCustomerScoreOnThis',
                    hideOnCustomerProfile: true,
                    render: calculatedCustomerScoreOnThis => calculatedCustomerScoreOnThis
                },
                {
                    title: i18n.t('customerRiskLevel'),
                    dataIndex: 'customer.riskLevel',
                    key: 'customer.riskLevel',
                    hideOnCustomerProfile: true,
                    render: customerRiskLevel => this.getCustomerRiskLevelName(customerRiskLevel)
                },
                {
                    title: i18n.t('txRuleKey'),
                    dataIndex: 'txRuleKey',
                    key: 'txRuleKey',
                    render: txRuleKey => txRuleKey
                },
                {
                    title: i18n.t('txRiskLevel'),
                    dataIndex: 'txRiskLevel',
                    key: 'txRiskLevel',
                    fixed: 'right',
                    render: (itemId, record) => this.txRiskLevel(record)
                },
                {
                    title: i18n.t('action'),
                    dataIndex: 'finalAction',
                    key: 'finalAction',
                    fixed: 'right',
                    width: '100px',
                    hideOnCustomerProfile: true,
                    render: (itemId, record) => this.finalAction(record)
                },
            ],
            items: [],
        }
    }

    finalAction(item) {
        const txId = item.txId;
        let finalAction = item.finalAction;

        if (izBlank(finalAction)) finalAction = "none"

        return <TransactionActionSelect txId={txId} finalAction={finalAction}/>;
    }

    extractFromTxData(item, wantedField) {
        return item.txData ? (item.txData[wantedField] ? item.txData[wantedField] : "") : "";
    }

    sanctionFound(item) {
        const searchLogId = item.searchLogId;

        let found = searchLogId && 0 < searchLogId
            && (item.sanctionFound === true || item.pepFound === true);

        return found ? (
            <div className="">
                <SearchCardModal itemId={searchLogId} text={i18n.t('showDetailsForTx')} danger/>
            </div>
        ) : <div className="sanction-check-button"><span>{i18n.t('showDetailsClean')}</span></div>;
    }

    getTxRiskLevel(riskLevel) {
        const txRiskLevels = this.props.common.txRiskLevels

        if (izEmpty(txRiskLevels) || this.izNotTxRiskLevelExist(riskLevel)) return {name: riskLevel, order: 11};

        return txRiskLevels.filter(txRiskLevel => txRiskLevel.code === riskLevel)[0];
    }

    getTxRiskLevelName(riskLevel) {
        return this.getTxRiskLevel(riskLevel).name
    }

    getTxRiskLevelOrder(riskLevel) {
        return this.getTxRiskLevel(riskLevel).order
    }

    getTxRiskLevelColor(txRiskLevel) {

        const order = this.getTxRiskLevelOrder(txRiskLevel);

        return DEFAULTS.txLevelColors[order];
    }

    getCustomerRiskLevel(riskLevel) {
        const customerRiskLevels = this.props.common.customerRiskLevels

        if (izEmpty(customerRiskLevels) || this.izNotCustomerRiskLevelExist(riskLevel)) return riskLevel;

        return customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel)[0];
    }

    getCustomerRiskLevelOrder(riskLevel) {
        return this.getCustomerRiskLevel(riskLevel).order
    }

    getCustomerRiskLevelColor(riskLevel) {

        const order = this.getCustomerRiskLevelOrder(riskLevel);

        return DEFAULTS.customerLevelColors[order];
    }

    getCustomerRiskLevelName(riskLevel) {
        const customerRiskLevels = this.props.common.customerRiskLevels

        if (izEmpty(customerRiskLevels) || this.izNotCustomerRiskLevelExist(riskLevel)) return riskLevel;

        let foundCustomerRiskLevel = customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel)[0]

        const customerRiskLevelColor = this.getCustomerRiskLevelColor(riskLevel);
        return <div className={"customer-risk-level customer-risk-level-" + customerRiskLevelColor} key={riskLevel}>
            {foundCustomerRiskLevel.name}
        </div>;
    }

    txRiskLevel(item) {
        const txRiskLevel = item.txRiskLevel;
        const txRiskLevelName = this.getTxRiskLevelName(txRiskLevel);

        const txRiskLevelColor = this.getTxRiskLevelColor(txRiskLevel);
        return <div className={"tx-risk-level tx-risk-level-" + txRiskLevelColor} key={txRiskLevel}>
            {txRiskLevelName}
        </div>;
    }

    txType(item) {
        return item.txType;
    }

    tcknVkn(item) {
        return item.customer.type === "P" ? item.customer.tckn : item.customer.vkn;
    }

    customerNo(customerNo) {
        return (
            <a
                href="#"
                onClick={(e) => {
                    this.goToCustomerProfile(customerNo, e)
                }}
            >{customerNo}</a>
        )
    }

    goToCustomerProfile(customerNo, event) {
        CustomerService.saveCustomerNoFromTx(customerNo)
        this.props.history.push('/customer-profile')
        event.preventDefault()
    }

    txId(item) {
        return (
            <div>{item.txId}</div>
        )
    }

    checkTxRiskLevels = () => {

        const txRiskLevels = this.state.txRiskLevels
        if (izNotEmpty(txRiskLevels)) return

        TransactionService.riskLevels()
            .then(
                response => {
                    if (response.data && response.data.success === true) {
                        const txRiskLevels = response.data.items

                        CommonService.saveTxRiskLevels(txRiskLevels)
                        this.props.commonAction(CHANGE_TX_RISK_LEVELS, txRiskLevels)
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    }
                }
            )
    }

    izNotTxRiskLevelExist = (riskLevel) => {
        const txRiskLevels = this.props.common.txRiskLevels
        if (izEmpty(txRiskLevels)) return true;
        return izEmpty(txRiskLevels.filter(txRiskLevel => txRiskLevel.code === riskLevel))
    }

    izNotCustomerRiskLevelExist = (riskLevel) => {
        const customerRiskLevels = this.props.common.customerRiskLevels
        if (izEmpty(customerRiskLevels)) return true;
        return izEmpty(customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel))
    }

    getFilteredColumns = (isCustomerProfile) => {

        let columns = this.state.columns

        if (isCustomerProfile) {
            columns = columns.filter(column => column.hideOnCustomerProfile !== true);
        }

        return columns;
    }

    render() {

        const {items, customerProfile} = this.props;
        const isCustomerProfile = customerProfile === true;

        const columns = this.getFilteredColumns(isCustomerProfile);

        return (
            <>
                {izNotEmpty(items) ?
                    <>

                        {isCustomerProfile !== true &&
                            <div className="transaction-search-result-count">
                                <strong>{items.length}</strong> {i18n.t('recordsFound')}
                            </div>
                        }

                        <Table
                            columns={columns}
                            dataSource={items}
                            pagination={{
                                hideOnSinglePage: isCustomerProfile,
                                defaultPageSize: 20,
                                total: items.length,
                                pageSizeOptions: ["20", "50", "100"],
                                showSizeChanger: true,
                                locale: {items_per_page: ""}
                            }}
                            scroll={{x: 'max-content'}}
                            scrollToFirstRowOnChange={true}
                            className="transaction-search-result-table"
                        />
                    </>
                    :
                    <>
                        <div className="transaction-search-result-count">{i18n.t('recordsNotFound')}</div>
                    </>
                }
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionTable);